// export const FETCH_URL = "http://localhost:7000";
// export const CAMS_URL = "http://localhost:8000";

export const FETCH_URL = "https://transcity.dmsi-sims.com";
export const CAMS_URL = "https://portal.dmsi-sims.com";
